function ManageBtnArea(props: any) {
  let myProps = {
    setWriteState: () => { },
    goDelete: () => { },
    open_multy_modify_popup: (inData:any) => { },
    go_excel_download: (inData:any) => { },
    goCopyWrite: (inData:any) => { },
    ...props
  };

  return (
    <div style={{ position: "relative", textAlign: "right" }}>
      <button className="btn btn-sky ml-1" onClick={() => { myProps.setWriteState(); }}>신규</button>
      <button className="btn btn-red ml-1" onClick={myProps.goDelete}>삭제</button>
      <button className="btn btn-sky ml-1" onClick={()=>{myProps.open_multy_modify_popup({});}}>일괄수정</button>
      <button className="btn btn-sky ml-1" onClick={()=>{myProps.go_excel_download({});}}>엑셀다운</button>
      <button className="btn btn-sky ml-1" onClick={()=>{myProps.goCopyWrite({});}}>복사</button>
    </div>
  );
};
export default ManageBtnArea;